import {Injectable} from '@angular/core';
import {filter, map} from 'rxjs/operators';
import {BasicEpic} from './basic.epic';
import {PollActions} from '../actions/poll.actions';
import {PollService} from '../services/poll.service';
import {
    EventObject,
    EventService,
    LoggerService,
    StoreActionsEnum,
    StoreEventsEnum
} from '../../../modules/hbs-services';
import {ToastService} from "ng-uikit-pro-standard";

@Injectable()
export class QuestionEpics extends BasicEpic {

    protected epicNames = [
        'updateQuestions',
        'replaceAllQuestionsAndUpdateScriptQuestSets',
        'deleteQuestions'
    ];

    constructor(private pollService: PollService,
                private eventService: EventService,
                private toastService: ToastService,
                private logger: LoggerService) {
        super();
    }

    private updateQuestions = BasicEpic.createEpic(
        StoreActionsEnum.UPDATE_QUESTIONS,
        ({payload}) => {
            this.logger.log('storage@QuestionEpics: updateQuestions', payload);
            return this.pollService
                .updateQuestions(payload.questions, payload.pollId)
                .pipe(
                    filter(data => {
                        // console.log('filter: data', data);
                        if (data && data['_isValidation']) {
                            return false;
                        }
                        if (payload.effect && payload.effect.toast) {
                            this.toastService.info(payload.effect.toast);
                        }
                        this.eventService.emit(new EventObject(StoreEventsEnum.CLOSE_EDIT_QUESTION, payload));
                        return true;
                    }),
                    map(PollActions.questionsUpdated)
                );
        });

    private replaceAllQuestionsAndUpdateScriptQuestSets = BasicEpic.createEpic(
        StoreActionsEnum.REPLACE_ALL_QUESTIONS_AND_SCRIPTQUESTSETS,
        ({payload}) => {
            this.logger.log('storage@QuestionEpics: replaceAllQuestionsAndUpdateScriptQuestSets', payload);
            return this.pollService
                .replaceAllQuestionsAndUpdateScriptQuestSets(payload.questions, payload.scriptQuestSets,
                    payload.questNumPairs, payload.keepResponses, payload.pollId)
                .pipe(
                    filter(data => {
                        // console.log('filter: data', data);
                        if (data && data['_isValidation']) {
                            return false;
                        }
                        this.eventService.emit(new EventObject(StoreEventsEnum.CLOSE_EDIT_QUESTION, payload));
                        return true;
                    }),
                    map(PollActions.allQuestionsAndScriptQuestSetsReplaced)
                );
        });

    /**
     * returns entire poll
     * @type {function(any, any, any): any}
     */
    private deleteQuestions = BasicEpic.createEpic(
        StoreActionsEnum.DELETE_QUESTIONS,
        ({payload}) => {
            this.logger.log('storage@QuestionEpics: deleteQuestions', payload);
            return this.pollService
                .deleteQuestions(payload.questNums, payload.pollId)
                .pipe(
                    map(PollActions.questionsDeleted)
                );
        });


}
